import {NgModule} from "@angular/core";
import {MyreportSearchPageComponent} from "./myreport/myreport-search-page/myreport-search-page.component";
import {FrameworkModule} from "../framework/framework.module";
import {SharedModule} from "../shared/shared.module";
import {EmployeeSharedModule} from "../employee/employee.shared.module";
import {MyreportEditPageComponent} from "./myreport/myreport-edit-page/myreport-edit-page.component";
import {DateTimeSharedModule} from "../datetime/datetime.shared.module";
import {CustomReportComponent} from "./custom-reports/custom-report/custom-report.component";
import {StockSharedModule} from "../stock/stock.shared.module";
import {SaleSharedModule} from "../sale/sale.shared.module";
import {ReportsSharedModule} from "./reports.shared.module";
import {PosSharedModule} from "../pos/pos.shared.module";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        PosSharedModule,
        ReportsSharedModule,
        EmployeeSharedModule,
        DateTimeSharedModule,
        StockSharedModule,
        SaleSharedModule
    ],
    declarations: [
        MyreportSearchPageComponent,
        MyreportEditPageComponent,
        CustomReportComponent
    ],
    exports: [
        MyreportSearchPageComponent,
        MyreportEditPageComponent,
        CustomReportComponent
    ]
})
export class ReportsModule {

}
